import React from 'react'
import './style.css'

const IntigrationIconsSection = ({ content }) => {
    return (
        <>
            <section className="integration-icon-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="integration-icon-heading">{content?.heading}</h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="integration-icon-grid">
                                {content?.cardsData?.map((card, index) => {
                                    return <div className="integration-icon-item" key={index}>
                                        <div className="integration-icon-box">
                                            <img src={card?.icon} alt="GPT" className="integration-icon-img" />
                                        </div>
                                        <p className="integration-icon-name">{card.title}</p>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default IntigrationIconsSection